export const PAGES_NAVIGATE_METHODS = {
  INDEX: "index",
  CREATE: "create",
  UPDATE: "update",
  SHOW: "show",
  DELETE: "delete",
} as const;

export type PagesNavigateMethodsType =
  (typeof PAGES_NAVIGATE_METHODS)[keyof typeof PAGES_NAVIGATE_METHODS];
